/**
 * 周天至周六（中文）
 * @return {string[]}
 */
export const weekAryCn: string[] = ['日', '一', '二', '三', '四', '五', '六']
